var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBillSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.655,
    height: 35.448,
    viewBox: "0 0 35.655 35.448",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(.707 .698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "none",
    stroke: "#218751",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M34.25 0L9.679 34.25 0 24.571"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBillSuccess);
export default __webpack_public_path__ + "static/media/icon-bill-success.118aa583764b52f70cf87939cfdc54f5.svg";
export { ForwardRef as ReactComponent };